<template>
  <span class="text-body-2">
    <span v-for="(researcher, i) in sortedResearchers" :key="i">
      <span class="font-weight-bold"> {{ getName(researcher) }}</span
      ><template v-if="i <= researchers.length - 3">,</template>
      <template v-else-if="i === researchers.length - 2">
        and
      </template>
    </span>
  </span>
</template>

<script>
import { Researcher } from '@/models';
import { typeHelpers } from '@/modules';

export default {
  name: 'ResearcherInlineList',
  props: {
    researchers: {
      type: Array,
      required: true,
      validator: (val) => typeHelpers.isArrayOfType(val, Researcher),
    },
    currentResearcher: {
      type: Researcher,
      default: null,
    },
  },
  computed: {
    sortedResearchers() {
      const youIndex = this.researchers.findIndex(
        (r) => r.id === this.currentResearcher?.id
      );
      if (youIndex === -1) {
        return this.researchers;
      }
      const you = this.researchers[youIndex];
      const others = this.researchers.filter(
        (r) => r.id !== this.currentResearcher?.id
      );
      return [you, ...others];
    },
  },
  methods: {
    getName(researcher) {
      if (
        this.currentResearcher &&
        researcher.id === this.currentResearcher.id
      ) {
        return 'You';
      }
      return researcher.name;
    },
  },
};
</script>
